// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V22H16.5V14H7.5V22H2V2ZM8 9V6H6V9H8ZM13 9V6H11V9H13ZM16 9H18V6H16V9Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 22V16H14.5V22H9.5Z"}}]};

const Houses1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'houses-1-filled',
    ref,
    icon: element,
  },
));

Houses1FilledIcon.displayName = 'Houses1FilledIcon';

export default Houses1FilledIcon;
